module.exports = __webpack_public_path__ + "fonts/fa-solid-900.dbf1fc91.woff2";